'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var Bucket = require('hamt-sharding/src/bucket');

var multihashing = require('multihashing-async'); // FIXME: this is copy/pasted from ipfs-unixfs-importer/src/dir-sharded.js


var hashFn = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
    var hash, justHash, length, result, i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return multihashing(Buffer.from(value, 'utf8'), 'murmur3-128');

          case 2:
            hash = _context.sent;
            // Multihashing inserts preamble of 2 bytes. Remove it.
            // Also, murmur3 outputs 128 bit but, accidently, IPFS Go's
            // implementation only uses the first 64, so we must do the same
            // for parity..
            justHash = hash.slice(2, 10);
            length = justHash.length;
            result = Buffer.alloc(length); // TODO: invert buffer because that's how Go impl does it

            for (i = 0; i < length; i++) {
              result[length - i - 1] = justHash[i];
            }

            return _context.abrupt("return", result);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function hashFn(_x) {
    return _ref.apply(this, arguments);
  };
}();

hashFn.code = 0x22; // TODO: get this from multihashing-async?

var addLinksToHamtBucket = function addLinksToHamtBucket(links, bucket, rootBucket) {
  return Promise.all(links.map(function (link) {
    if (link.Name.length === 2) {
      var pos = parseInt(link.Name, 16);
      return bucket._putObjectAt(pos, new Bucket({
        hashFn: hashFn
      }, bucket, pos));
    }

    return rootBucket.put(link.Name.substring(2), true);
  }));
};

var toPrefix = function toPrefix(position) {
  return position.toString('16').toUpperCase().padStart(2, '0').substring(0, 2);
};

var toBucketPath = function toBucketPath(position) {
  var bucket = position.bucket;
  var path = [];

  while (bucket._parent) {
    path.push(bucket);
    bucket = bucket._parent;
  }

  path.push(bucket);
  return path.reverse();
};

var findShardCid = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(node, name, ipld, context, options) {
    var position, prefix, bucketPath, link;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!context) {
              context = {
                rootBucket: new Bucket({
                  hashFn: hashFn
                }),
                hamtDepth: 1
              };
              context.lastBucket = context.rootBucket;
            }

            _context2.next = 3;
            return addLinksToHamtBucket(node.Links, context.lastBucket, context.rootBucket);

          case 3:
            _context2.next = 5;
            return context.rootBucket._findNewBucketAndPos(name);

          case 5:
            position = _context2.sent;
            prefix = toPrefix(position.pos);
            bucketPath = toBucketPath(position);

            if (bucketPath.length > context.hamtDepth) {
              context.lastBucket = bucketPath[context.hamtDepth];
              prefix = toPrefix(context.lastBucket._posAtParent);
            }

            link = node.Links.find(function (link) {
              var entryPrefix = link.Name.substring(0, 2);
              var entryName = link.Name.substring(2);

              if (entryPrefix !== prefix) {
                // not the entry or subshard we're looking for
                return;
              }

              if (entryName && entryName !== name) {
                // not the entry we're looking for
                return;
              }

              return true;
            });

            if (link) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return", null);

          case 12:
            if (!(link.Name.substring(2) === name)) {
              _context2.next = 14;
              break;
            }

            return _context2.abrupt("return", link.Hash);

          case 14:
            context.hamtDepth++;
            _context2.next = 17;
            return ipld.get(link.Hash, options);

          case 17:
            node = _context2.sent;
            return _context2.abrupt("return", findShardCid(node, name, ipld, context, options));

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function findShardCid(_x2, _x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

module.exports = findShardCid;